import {createFileRoute, redirect} from '@tanstack/react-router'
import {isAuthenticated} from "../utils/auth.ts";
import ResetPasswordForm from "../components/Auth/ResetPasswordForm.tsx";

export const Route = createFileRoute('/reset-password')({
  beforeLoad: async () => {
    if(isAuthenticated()) {
      throw redirect({to: '/sessions', replace: true});
    }
  },
  component: ResetPasswordForm
});
